/* VDS — Voie Du Succès · interactions */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Digital content: the buyer must ask for immediate access and waive the 14-day
  // withdrawal right (art. L221-28 13° Code de la consommation) before checking out.
  var WAIVER_TEXT = 'Je demande l’accès immédiat au guide et je renonce à mon droit de rétractation ' +
    '(art. L221-28 13° du Code de la consommation). J’accepte les ' +
    '<a href="/pages/conditions-generales-de-vente" target="_blank" rel="noopener">conditions générales de vente</a>.';
  var waiverAccepted = false;

  function addWaivers() {
    var buttons = document.querySelectorAll('button[name="checkout"], input[name="checkout"]');
    buttons.forEach(function (btn) {
      if (btn.dataset.vdsWaiver) return;
      btn.dataset.vdsWaiver = '1';
      var id = 'vds-waiver-' + Math.random().toString(36).slice(2, 8);
      var box = document.createElement('div');
      box.className = 'vds-waiver';
      box.style.cssText = 'display:flex;gap:1rem;align-items:flex-start;text-align:left;margin:0 0 1.2rem;font-size:1.3rem;line-height:1.45;';
      box.innerHTML = '<input type="checkbox" id="' + id + '" style="flex:none;width:1.8rem;height:1.8rem;margin:.2rem 0 0;accent-color:#121214;cursor:pointer">' +
        '<label for="' + id + '" style="cursor:pointer">' + WAIVER_TEXT + '</label>';
      btn.parentNode.insertBefore(box, btn);
      var cb = box.querySelector('input');
      cb.checked = waiverAccepted;
      var sync = function () {
        waiverAccepted = cb.checked;
        btn.disabled = !cb.checked;
        btn.setAttribute('aria-disabled', String(!cb.checked));
      };
      cb.addEventListener('change', sync);
      sync();
    });
  }

  ready(function () {
    addWaivers();
    // The cart drawer re-renders its footer after each update: re-attach the waiver.
    if ('MutationObserver' in window) {
      new MutationObserver(addWaivers).observe(document.body, { childList: true, subtree: true });
    }

    // Header shadow once the page scrolls
    var onScroll = function () { document.body.classList.toggle('vds-scrolled', window.scrollY > 10); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Reveal on scroll
    var reveals = document.querySelectorAll('.vds-reveal');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    }

    if (reduce || !fine) return;

    // Holographic tilt: the shine follows the pointer, the card leans toward it
    document.querySelectorAll('[data-vds-holo]').forEach(function (card) {
      var baseRy = getComputedStyle(card).getPropertyValue('--ry').trim();
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        card.style.setProperty('--mx', (x * 100) + '%');
        card.style.setProperty('--my', (y * 100) + '%');
        card.style.setProperty('--ry', ((x - 0.5) * 16) + 'deg');
        card.style.setProperty('--rx', ((0.5 - y) * 16) + 'deg');
      });
      card.addEventListener('mouseleave', function () {
        card.style.setProperty('--mx', '50%');
        card.style.setProperty('--my', '50%');
        card.style.setProperty('--ry', baseRy || '0deg');
        card.style.setProperty('--rx', '0deg');
      });
    });
  });
})();
